import wisePayment from "../assets/images/wisePayment.png";
import postBankPayment from "../assets/images/postBankPayment.png";

export const PaymentMethods = [
    {
        id: "wise",
        name: "wise",
        logo: wisePayment
    },
    {
        id: "postBank",
        name: "japan post bank",
        logo: postBankPayment
    },
]